const OnlineTaskStatus = Object.freeze({
    PENDING: 'pending',
    RUNNING: 'running',
    FINISHED: 'finished',
    FAILED: 'failed',
});

module.exports = OnlineTaskStatus;
